import script from "./DrawingToolModeControls.vue?vue&type=script&setup=true&lang=js"
export * from "./DrawingToolModeControls.vue?vue&type=script&setup=true&lang=js"

import "./DrawingToolModeControls.vue?vue&type=style&index=0&id=f7a60f96&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7a60f96"]])

export default __exports__